import { Building2, Inbox } from "lucide-react";

import type { PilotRequest } from "@/api/platform";
import { PlatformEmptyState } from "@/components/platform/ui/PlatformEmptyState";
import { PlatformStatusBadge } from "@/components/platform/ui/PlatformStatusBadge";

type PilotRequestListProps = {
  requests: PilotRequest[];
  selectedId: string | null;
  onSelect: (id: string) => void;
};

export function PilotRequestList({
  requests,
  selectedId,
  onSelect,
}: PilotRequestListProps) {
  if (requests.length === 0) {
    return (
      <div className="p-6">
        <PlatformEmptyState
          title="No pilot requests found"
          description="Try adjusting the current search or status filter."
          icon={Inbox}
        />
      </div>
    );
  }

  return (
    <div className="divide-y divide-slate-200">
      {requests.map((request) => {
        const active = request.id === selectedId;

        return (
          <button
            key={request.id}
            type="button"
            onClick={() => onSelect(request.id)}
            className={[
              "block w-full border-l-4 px-5 py-5 text-left transition",
              active
                ? "border-indigo-600 bg-indigo-50"
                : "border-transparent hover:bg-slate-50",
            ].join(" ")}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <Building2 className="h-4 w-4 shrink-0 text-slate-400" />

                  <p className="truncate font-semibold text-slate-900">
                    {request.church_name}
                  </p>
                </div>

                <p className="mt-2 truncate text-sm text-slate-500">
                  {request.contact_name}
                </p>

                <p className="mt-1 truncate text-xs text-slate-400">
                  {request.current_system?.trim() ||
                    "Current system not provided"}
                </p>
              </div>

              <PlatformStatusBadge status={request.status} />
            </div>
          </button>
        );
      })}
    </div>
  );
}